export const PayPeriod = Object.freeze({
  MONTHLY: 'monthly',
  ANNUALLY: 'yearly'
})
